import { ClockCircleOutlined, HourglassOutlined, TagOutlined } from '@ant-design/icons';
import { Tag } from 'antd';
import type { ReactNode } from 'react';
import type { TariffType } from '@goelectric/shared-types';
import { darkColors, neutralColors, semanticColors } from '@goelectric/ui-components';
import { StatusBadgeShell, StatusIcon, useStatusColor } from '@/components/StatusBadgeShell';
import { TARIFF_TYPE_DESCRIPTIONS, TARIFF_TYPE_LABELS } from '../utils/format';

const TYPE_ICONS: Record<TariffType, ReactNode> = {
  FLAT: <TagOutlined />,
  TOU: <ClockCircleOutlined />,
  IDLE_FEE: <HourglassOutlined />,
};

/** Tipo de tarifa con icono + texto (no depende solo del color). */
export function TariffTypeBadge({ type }: { type: TariffType }) {
  return (
    <Tag icon={TYPE_ICONS[type]} title={TARIFF_TYPE_DESCRIPTIONS[type]}>
      {TARIFF_TYPE_LABELS[type]}
    </Tag>
  );
}

/** Marca de configuración OCPI: color + icono + texto (WCAG 2.2 AA). */
export function TariffOcpiBadge({ published }: { published: boolean }) {
  const color = useStatusColor(
    published ? semanticColors.success : neutralColors.textMuted,
    published ? darkColors.success : darkColors.textMuted,
  );
  const label = published ? 'Marcada para OCPI' : 'No marcada para OCPI';
  return (
    <StatusBadgeShell
      color={color}
      icon={<StatusIcon iconKey={published ? 'check' : 'offline'} />}
      label={label}
      title={
        published
          ? 'Marca de configuración: se publicará cuando se habilite la integración OCPI (US 5.2). La sincronización aún no está implementada.'
          : 'Marca de configuración: no se publicará por OCPI cuando se habilite la integración (US 5.2).'
      }
    />
  );
}
